import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _omit from "lodash/omit";
import { LogLevel } from '@statsig/client-core';
import { StatsigClient } from '@statsig/js-client';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';
import UAParser from 'ua-parser-js';
import { getToken } from '../auth/context';
import { BASE_ENDPOINT } from '../client';
import transactionId from '../logging/transactionId';
import session from '../session';
import { StatsigEnvironment } from './constants';

const getDeviceData = () => {
  const parser = new UAParser();
  const browser = parser.getBrowser();
  const device = parser.getDevice();
  return {
    browser: browser.name || '',
    device_model: device.model || '',
    device_type: device.type || 'desktop'
  };
};

export const createStatsigClient = ({
  clientSdkKey,
  environment: environmentProp,
  customUserAttribute: customUserAttributeProp,
  statsigOptions: statsigOptionsProp
}) => {
  if (!clientSdkKey || !environmentProp) {
    throw new Error('Missing sdk key or environment');
  }

  const deviceData = getDeviceData();
  const customUserAttributes = { ...deviceData,
    ...customUserAttributeProp
  };
  const environment = [StatsigEnvironment.Production, StatsigEnvironment.Staging, StatsigEnvironment.Development].includes(environmentProp) ? environmentProp : StatsigEnvironment.Development;
  const statsigOptions = {
    plugins: [new StatsigAutoCapturePlugin()],
    logLevel: environment === StatsigEnvironment.Production ? LogLevel.Warn : LogLevel.Debug,
    ...statsigOptionsProp,
    environment: {
      tier: environment
    }
  };
  return new StatsigClient(clientSdkKey, {
    custom: customUserAttributes
  }, statsigOptions);
};
export const resolveStatsigExperimentOrGate = (client, key, options) => {
  const experimentResult = client.getExperiment(key, {
    disableExposureLog: true
  });
  const isRecognizedExperiment = Object.keys(experimentResult.value).length > 0 && !experimentResult.details.reason.includes('Unrecognized');

  if (isRecognizedExperiment) {
    return { ...client.getExperiment(key, options),
      type: 'experiment'
    };
  }

  return { ...client.getFeatureGate(key, options),
    type: 'feature-gate'
  };
};
export const transformGateToVariant = gate => {
  return { ...gate,
    groupName: null
  };
};
export const transformExperimentToVariant = experiment => {
  return { ..._omit(experiment, 'get'),
    groupName: experiment.groupName || ''
  };
};
export const getHeaders = function () {
  var _ref = _asyncToGenerator(function* (authenticated) {
    const headersBase = transactionId ? {
      'x-transaction-id': transactionId
    } : {};
    const token = yield getToken();
    const isAuthed = authenticated === undefined ? !!token : authenticated && !!token;

    if (isAuthed) {
      return { ...headersBase,
        authorization: `Bearer ${token}`
      };
    } else {
      const sessionConfig = session.config();
      const sessionId = yield session.verify();

      if (sessionId) {
        return { ...headersBase,
          [sessionConfig.header]: sessionId
        };
      }
    }

    return headersBase;
  });

  return function getHeaders(_x) {
    return _ref.apply(this, arguments);
  };
}();
export const retrieveTrackingAlias = function () {
  var _ref2 = _asyncToGenerator(function* (arg) {
    const headers = yield getHeaders(arg === null || arg === void 0 ? void 0 : arg.authenticated);
    const namespace = (arg === null || arg === void 0 ? void 0 : arg.role) === 'advisor' ? 'advisor' : 'customer';
    const response = yield fetch(`${BASE_ENDPOINT}/${namespace}/tracking-alias`, {
      headers
    });
    const data = yield response.json();
    return data;
  });

  return function retrieveTrackingAlias(_x2) {
    return _ref2.apply(this, arguments);
  };
}();